import { ApplicationConfig, inject, Inject, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { OAuthService, provideOAuthClient, UrlHelperService } from 'angular-oauth2-oidc';
import { OepaAuthProfile, OepaIopAuthLibService } from '@ohioepa/oepa-iop-auth-lib';
import { environment } from '../environments/environment';

const profile: OepaAuthProfile = {
  clientId: environment.clientID,
  redirectUri: environment.redirectURI,
}

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
  provideRouter(routes),
  provideHttpClient(withInterceptorsFromDi()),
  { provide: APP_BASE_HREF, useValue: '/online-payments' },
  provideAnimationsAsync(),
  provideOAuthClient(),
    UrlHelperService,
  {
    provide: OepaIopAuthLibService,
    useFactory: () => {
      return new OepaIopAuthLibService(inject(OAuthService), profile)
    }
  }
  ]
};
